import { defineComponent as p, ref as g, computed as d, resolveComponent as m, openBlock as l, createElementBlock as f, normalizeClass as t, createElementVNode as a, createVNode as y, normalizeProps as h, guardReactiveProps as _, renderSlot as v, createTextVNode as b, toDisplayString as I, createBlock as w, withModifiers as O, createCommentVNode as S } from "vue";
import { O as C } from "./OrIconButton-BlHCLpeW.mjs";
import { O as N, I as n } from "./OrIndicator-CCrOseW7.mjs";
import { _ as B } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var o = /* @__PURE__ */ ((r) => (r.Success = "success", r.Warning = "warning", r.Error = "error", r.Info = "info", r))(o || {});
const $ = {
  success: "check_circle",
  warning: "warning",
  error: "error",
  info: "info"
}, x = [
  // Layout
  "layout-row items-start",
  // Shape
  "rounded-md",
  // Spacing
  "px-md",
  "py-md",
  "gap-md",
  // Typography
  "typography-body-2-regular",
  // Typography (children)
  "[&_:any-link]:typography-body-2-bold",
  // Elevation
  "shadow-contextual",
  "dark:shadow-contextual-dark",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], E = {
  [o.Success]: [
    // Theme
    "theme-background-success-container",
    "dark:theme-background-success-container-dark",
    // Theme (children)
    "[&_:any-link]:theme-foreground-success",
    "dark:[&_:any-link]:theme-foreground-success-dark"
  ],
  [o.Warning]: [
    // Theme
    "theme-background-warning-container",
    "dark:theme-background-warning-container-dark",
    // Theme (children)
    "[&_:any-link]:theme-foreground-warning",
    "dark:[&_:any-link]:theme-foreground-warning-dark"
  ],
  [o.Error]: [
    // Theme
    "theme-background-error-container",
    "dark:theme-background-error-container-dark",
    // Theme (children)
    "[&_:any-link]:theme-foreground-error",
    "dark:[&_:any-link]:theme-foreground-error-dark"
  ],
  [o.Info]: [
    // Theme
    "theme-background-primary-container",
    "dark:theme-background-primary-container-dark",
    // Theme (children)
    "[&_:any-link]:theme-foreground-primary",
    "dark:[&_:any-link]:theme-foreground-primary-dark"
  ]
}, V = p({
  name: "OrNotification",
  components: {
    OrIndicator: N,
    OrIconButton: C
  },
  props: {
    variant: {
      type: String,
      default: () => o.Info
    },
    disableClose: {
      type: Boolean,
      default: !1
    },
    message: {
      type: String,
      default: void 0
    }
  },
  expose: [
    "root"
  ],
  setup(r) {
    const e = g(), s = d(() => [
      "or-notification-v3",
      ...x,
      ...E[r.variant]
    ]), i = d(() => {
      const c = {
        [o.Success]: n.Success,
        [o.Warning]: n.Warning,
        [o.Error]: n.Error,
        [o.Info]: n.Neutral
      };
      return {
        icon: {
          icon: $[r.variant],
          variant: "filled-bold"
        },
        color: c[r.variant],
        size: "m"
      };
    });
    return {
      root: e,
      rootStyles: s,
      indicatorProps: i
    };
  }
}), z = {
  class: /* @__PURE__ */ t(["mt-[2px] md:mt-[2.5px]"])
}, P = {
  class: /* @__PURE__ */ t(["grow"])
}, W = {
  class: /* @__PURE__ */ t(["mt-[2px] md:mt-[2.5px]"])
};
function T(r, e, s, i, c, D) {
  const u = m("OrIndicator"), k = m("OrIconButton");
  return l(), f("div", {
    ref: "root",
    class: t(r.rootStyles)
  }, [
    a("div", z, [
      y(u, h(_(r.indicatorProps)), null, 16)
    ]),
    a("div", P, [
      v(r.$slots, "default", {}, () => [
        b(I(r.message), 1)
      ])
    ]),
    a("div", W, [
      r.disableClose ? S("", !0) : (l(), w(k, {
        key: 0,
        icon: "close",
        size: "m",
        onClick: e[0] || (e[0] = O((M) => r.$emit("close"), ["stop"]))
      }))
    ])
  ], 2);
}
const F = /* @__PURE__ */ B(V, [["render", T]]);
export {
  o as N,
  F as O,
  $ as V
};
//# sourceMappingURL=OrNotification-Dz3Tr1wI.mjs.map
